// extracted by mini-css-extract-plugin
export var chatHtmlText = "_re-2";
export var chatLink = "_re-0";
export var chatText = "_re-1";